import { memo } from "react";
import Svg, { Path, type SvgProps } from "react-native-svg";

const SvgPhone = (props: SvgProps) => (
  <Svg fill="none" height={25} width={24} {...props}>
    <Path
      clipRule="evenodd"
      d="M4.687 4.5c-.35 0-.675.132-.905.348a1.06 1.06 0 0 0-.344.742c.258 3.855 2.003 7.502 4.924 10.251 2.924 2.753 6.826 4.414 10.976 4.659.34-.006.655-.137.88-.348.228-.215.344-.494.344-.77V15.84l-4.218-1.588-1.25 1.963a1 1 0 0 1-1.265.37c-2.634-1.223-4.779-3.236-6.09-5.737a1 1 0 0 1 .394-1.335l2.035-1.15L8.526 4.5zM2.411 3.392A3.32 3.32 0 0 1 4.687 2.5h4.5a1 1 0 0 1 .92.609l2.25 5.294a1 1 0 0 1-.428 1.262L10 10.755a11.05 11.05 0 0 0 3.896 3.618l1.2-1.881a1 1 0 0 1 1.195-.399l5.625 2.118a1 1 0 0 1 .647.936v4.235c0 .847-.358 1.647-.973 2.226a3.32 3.32 0 0 1-2.334.89c-4.615-.264-8.979-2.108-12.264-5.2-3.287-3.094-5.268-7.224-5.551-11.616l-.003-.064c0-.847.359-1.647.974-2.226"
      fill={props.color}
      fillRule="evenodd"
    />
  </Svg>
);
const Memo = memo(SvgPhone);
export default Memo;
